<script>
import mergeArrayForKey from '@/utils/mergeArrayForKey'

export default ({ props, data }) => {
  const {
    list = [],
    type = 'default',
    size = 'small',
    plain = false,
    defaultList = [],
  } = props

  const buttons = mergeArrayForKey(defaultList, list, 'name')

  return buttons.map((b) => {
    const disabled =
      typeof b.disabled === 'function' ? b.disabled() : b.disabled
    const show = typeof b.show === 'function' ? b.show() : b.show

    const data = {
      props: {
        plain: b.plain || plain,
        type: b.type || type,
        size: b.size || size,
        disabled: disabled,
      },
      directives: [],
      on: {
        click: () => b.onClick(),
      },
    }

    if (b.permission) {
      const arr = b.permission.split(':')
      const arg = arr[0]
      const value = arr[1]

      data.directives.push({
        name: 'permission',
        arg,
        value,
      })
    }

    return (
      <el-button
        vShow={!b.hasOwnProperty('show') || show}
        {...data}
        key={b.name}
      >
        {b.name}
      </el-button>
    )
  })
}
</script>
